module.exports = __webpack_public_path__ + "img/mail.cf015432.svg";